import { createContext } from "react";

/** The signed-in merchant's auth token. Previews send it so their conversations
 * are created hidden and never bill as real shopper conversations. */
export const MerchantPreviewTokenContext = createContext<string | undefined>(
  undefined,
);
MerchantPreviewTokenContext.displayName = "MerchantPreviewTokenContext";
